import { useMemo } from "react";
import { defineAbilitiesForRole } from "./abilityBuilder";
import useAuth from "src/hooks/useAuth";
import { AbilityContext } from "./Can";
import UnAuth from "src/pages/unAuth";
import LoadingScreen from "src/components/loadingScreen";

const AclGuard = (props) => {
  const auth = useAuth();
  const { aclAbilities, children } = props;
  const subject = aclAbilities?.subject || "all";
  const ability = useMemo(() => {
    if (!auth?.user?.role) return undefined;
    const options = auth.user.role.options?.map((item) => item.value) || [];
    return defineAbilitiesForRole(auth.user.role.value, options, subject);
  }, [auth?.user, subject]);

  if (
    window.location.pathname === "/404" ||
    window.location.pathname === "/auth/login" ||
    window.location.pathname === "/auth/register" ||
    window.location.pathname === "/auth/forget-password" ||
    window.location.pathname === "/"
  ) {
    return <>{children}</>;
  }

  if (auth?.loading) {
    return <LoadingScreen />;
  }

  if (ability?.can("read", subject)) {
    return (
      <AbilityContext.Provider value={ability}>
        {children}
      </AbilityContext.Provider>
    );
  } else {
    return (
      <>
        <UnAuth />
      </>
    );
  }
};

export default AclGuard;
